import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "../ui/accordion";
import Reveal from "../Reveal";

const faqs = [
  { q: "Which devices does FolioStax work on?", a: "FolioStax runs on Windows PCs, laptops and Android tablets. You can also access reports on any browser via our cloud dashboard." },
  { q: "Does it support thermal printers?", a: "We support all standard 58mm and 80mm USB and network thermal printers, plus regular A4 inkjet/laser printers for invoices." },
  { q: "Can I use it without internet?", a: "Yes. FolioStax works fully offline at the counter and automatically syncs data to the cloud whenever you're back online." },
  { q: "Is my data safe?", a: "Your data is encrypted at rest and in transit. Cloud sync and automatic daily backups are included with the Pro plan." },
  { q: "Do you offer training and onboarding?", a: "Yes — we provide free onboarding for every customer, plus guided setup tailored to your business type." },
  { q: "Can I migrate from my current billing software?", a: "Absolutely. Our team helps you import items, customers and opening balances from Excel, Tally and most popular billing tools." },
  { q: "How do I get a custom quote?", a: "Email us or request a demo from the Contact section — our team will get back within one business day." },
];

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-24 lg:py-32 bg-slate-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <Reveal><p className="text-xs font-bold uppercase tracking-[0.2em] text-blue-800">FAQ</p></Reveal>
          <Reveal delay={80}>
            <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 mt-3">
              Questions, answered.
            </h2>
          </Reveal>
          <Reveal delay={140}>
            <p className="mt-4 text-base sm:text-lg text-slate-600">
              Everything you need to know before you book your demo.
            </p>
          </Reveal>
        </div>

        <Reveal delay={200}>
          <div className="mt-12 rounded-3xl bg-white border border-slate-200 p-3 sm:p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((f, i) => (
                <AccordionItem key={f.q} value={`faq-${i}`} data-testid={`faq-item-${i}`}>
                  <AccordionTrigger className="text-left font-display font-semibold text-slate-900 hover:text-blue-700 hover:no-underline">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
